import React from 'react'
import { FiClock, FiCpu, FiTrendingUp, FiMapPin } from 'react-icons/fi'

const features = [
  {
    icon: <FiClock className="text-4xl mb-4" />,
    title: 'Fast & Reliable',
    description: 'Deliveries in 2 hours or less, keeping your customers happy and your business moving.'
  },
  {
    icon: <FiCpu className="text-primary text-4xl mb-4" />,
    title: 'Seamless Integration',
    description: 'Connect your business to our platform via API or web dashboard for instant order management.'
  },
  {
    icon: <FiTrendingUp className="text-primary text-4xl mb-4" />,
    title: 'Scalable Solutions',
    description: 'Whether you need a single delivery or hundreds per day, Tuber adapts to your business needs.'
  },
  {
    icon: <FiMapPin className="text-primary text-4xl mb-4" />,
    title: 'Real-Time Tracking',
    description: 'Stay informed with live GPS tracking and proof of delivery.'
  },
]

const WhyChooseUs = () => {
  return (
    <section className='px-4 py-10 md:py-20'>
      <div className='max-w-7xl w-full mx-auto'>
        <div>
          <span className="text-primary font-bold uppercase mb-2 text-base md:text-lg block text-center">Confidence</span>
          <h1 className="text-3xl md:text-4xl font-bold text-headings text-center">
            Why Choose Tuber?
          </h1>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 bg-white overflow-hidden mt-10'>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`p-8 md:p-10 border border-gray-200 shadow-shadow-5 rounded-xl space-y-8 ${index === 0 ? 'bg-primary text-white' : 'bg-white text-black'
                }`}
            >
              <span>{feature.icon}</span>
              <div>
                <h2 className='text-xl font-bold mb-2'>{feature.title}</h2>
                <p className='text-base font-medium'>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs
